import { GraphQLSource, type Source } from '.'

export default async function createGraphQLSource (queryValue: string): Promise<Source> {
  const document = await import(`../../../../javascripts/queries/${queryValue}.gql`) as { default: string }
  return new GraphQLSource(document.default)
}
